import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle, Shield, Award } from "lucide-react";

export default function DentalCare() {
  const { t } = useTranslation();

  return (
    <div className="pt-20">
      <Helmet>
        <title>Dental Implants & Veneers in Turkey | Monimek Dental Care</title>
        <meta name="description" content="Save up to 70% on full-mouth dental implants and Hollywood smile veneers in Turkey. State-of-the-art clinics and top-rated dentists in Istanbul." />
        <link rel="canonical" href="https://www.monizmek.com/treatments/dental-care" />
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "MedicalProcedure",
              "name": "Dental Implants & Veneers",
              "description": "Premium dental implant surgery and cosmetic dentistry (veneers, crowns) at JCI-accredited dental clinics in Turkey.",
              "bodyLocation": "Mouth",
              "procedureType": "Surgical",
              "provider": {
                "@type": "MedicalBusiness",
                "name": "Monimek Partner Clinics",
                "address": {
                  "@type": "PostalAddress",
                  "addressCountry": "Turkey",
                  "addressLocality": "Istanbul"
                }
              },
              "offers": {
                "@type": "AggregateOffer",
                "priceCurrency": "USD",
                "lowPrice": "3000",
                "highPrice": "8000",
                "offerCount": "2"
              }
            }
          `}
        </script>
      </Helmet>

      <section className="bg-[#F8FAFC] py-20">
        <div className="max-w-[1200px] mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h1 className="text-4xl sm:text-5xl font-black text-[#0B3C5D] font-outfit mb-6">Cosmetic Dental Care in Turkey</h1>
            <p className="text-lg text-[#6B7280] mb-8">
              Achieve the perfect smile for a fraction of US costs. Our partner dental clinics in Turkey specialize in Full-Mouth Implants (All-on-4, All-on-6), Zirconium crowns, and E-max veneers, using cutting-edge 3D scanning and panoramic robotics.
            </p>
            <Link to="/contact" className="inline-flex items-center gap-2 px-8 py-4 bg-[#3FA7D6] text-white font-bold rounded-full hover:bg-[#0B3C5D] transition-colors">
              Get Your Free Estimate <ArrowRight className="w-5 h-5" />
            </Link>
          </div>
          <div>
            <img src="https://images.pexels.com/photos/3845981/pexels-photo-3845981.jpeg?auto=compress&cs=tinysrgb&w=800" alt="Dental Implants Turkey Clinic" className="rounded-3xl shadow-xl w-full h-[400px] object-cover" />
          </div>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-[1000px] mx-auto px-6">
          <h2 className="text-3xl font-bold text-[#0B3C5D] font-outfit mb-8 text-center">Why Travel to Turkey for Dental Care?</h2>
          <div className="grid sm:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100">
              <Award className="w-10 h-10 text-[#3FA7D6] mb-4" />
              <h3 className="font-bold text-lg mb-2">Expert Dentists</h3>
              <p className="text-[#6B7280] text-sm">Our network includes highly specialized cosmetic and implant dentists delivering flawless Hollywood smiles.</p>
            </div>
            <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100">
              <Shield className="w-10 h-10 text-[#3FA7D6] mb-4" />
              <h3 className="font-bold text-lg mb-2">Premium Materials</h3>
              <p className="text-[#6B7280] text-sm">We strictly utilize internationally certified materials (Straumann, Nobel Biocare, E-max).</p>
            </div>
            <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100">
              <CheckCircle className="w-10 h-10 text-[#3FA7D6] mb-4" />
              <h3 className="font-bold text-lg mb-2">Vacation & Recovery</h3>
              <p className="text-[#6B7280] text-sm">Combine your dental treatments with a relaxing recovery vacation in historic Istanbul or serene Antalya.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
